import React from 'react';
import Icon from './Icon';

function DemoSlot() {
  return (
    <section id="demo">
      <div className="wrap">
        <div className="sec-head">
          <div className="eyebrow">See it live</div>
          <h2>Watch Salesyo run an entire conversation</h2>
          <p>An interactive walkthrough of the operator, from the first "how much?" to the booked call. Explore it at your own pace.</p>
        </div>
        {/* Replace this placeholder with the real demo embed (Arcade / Storylane / Supademo / Loom / <iframe>). Keep the 16:9 ratio. */}
        <div className="demo-slot">
          <span className="badge2">Interactive demo</span>
          <div>
            <div className="di"><Icon name="play" size={38} /></div>
            <h3>Your interactive demo goes here</h3>
            <p>Paste your embed in this slot. It's sized 16:9 and already matches the page. Just replace this placeholder block with your <code>&lt;iframe&gt;</code> or embed script.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DemoSlot;
